

























































import { Component, Watch, Vue } from 'vue-property-decorator'
/* component */
import CommonHeader from '@/app/components/Common/Header.vue'
import PageTitle from '@/app/components/Common/PageTitle.vue'
import Loading from '@/app/components/Common/Loading.vue'
import MyPageInfo from '@/app/components/MyPage/MypageInfo.vue'
/* api */
import MypageApi from '@/app/model/api/mypageApi'
/* module */
import Local from '@/app/module/local'
import CommonClass from '@/app/module/common'
import { routerPath, userType, errorFlag } from '@/app/model/store/domain/const'

@Component({
  components: {
    CommonHeader,
    PageTitle,
    Loading,
    MyPageInfo
  }
})
export default class Mypage extends Vue {
  private userData: any = {}
  private keyData: any = {}
  private userType: number = 0
  private displayMyFieldList: any = []
  private myFieldList: any = []
  private ownerList: any = []
  private fieldDetailsData: any[] = []
  private showNotFound: boolean = false
  private showLoading: boolean = true
  private showListLoading: boolean = true
  private getUserDataFlag: boolean = true

  private get myApiState (): boolean {
    return this.$store.state.setFlagState.myApiKeyFlag
  }

  @Watch('myApiState')
  onLodingChange (flag: boolean) {
    if (flag && this.getUserDataFlag) {
      this.showLoading = true
    } else {
      this.showLoading = false
    }
  }

  created () {
    this.getUserData()
  }

  private changeLoading () {
    this.showLoading = !this.showLoading
  }

  private getUserData () {
    (async () => {
      const result = await MypageApi.getUserData()

      if (result.isOk()) {
        this.userData = result.getPayload()
        this.getUserDataFlag = true
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
      this.showLoading = false
    })()
  }
}
